import { useState, useEffect } from "react";
import "@/App.css";
import LockScreen from "@/pages/LockScreen";
import Dashboard from "@/pages/Dashboard";
import { Toaster } from "sonner";

const STORAGE_KEY = "krishinvest_unlocked_v1";

function App() {
  const [unlocked, setUnlocked] = useState(false);
  const [booted, setBooted] = useState(false);

  useEffect(() => {
    try {
      const v = sessionStorage.getItem(STORAGE_KEY);
      if (v === "1") setUnlocked(true);
    } catch (e) { /* ignore */ }
    setBooted(true);
  }, []);

  const handleUnlock = () => {
    try { sessionStorage.setItem(STORAGE_KEY, "1"); } catch (e) { /* ignore */ }
    setUnlocked(true);
  };

  if (!booted) return null;

  return (
    <div className="App min-h-screen bg-[#030305] text-white">
      {unlocked ? <Dashboard /> : <LockScreen onUnlock={handleUnlock} />}
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default App;
